import React from 'react'
import Hero from './hero'
import Banner from './banner'
import { Link } from 'react-router-dom'
import RoomsContainer from './roomsContainer'
function Rooms() {
    return (
    <>
        <Hero hero='roomsHero'>
            <Banner title='Our Rooms' subtitle='Check Out Our Comforting Rooms'>
               <Link to='/' className='btn-primary'>
                   Return Home
               </Link>
           </Banner>
        </Hero>
        <RoomsContainer />
    </>
    )
}

export default Rooms
